<template>
  <a
    class="flex gap-x-2 items-center cursor-pointer no-underline !text-white"
    href="https://magiceden.io"
    target="_blank"
  >
    <base-icon name="magic-eden" size="w-10 h-10" />
    <span class="font-medium hidden sm:flex break-normal lg:hidden xl:flex">
      Magic Eden
    </span>
  </a>
</template>
